import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    "input",
    "color"
  ]

  static values = {
    "selected": String
  }

  connect () {
    const pre_select = document.querySelector(`.colors .profile-color[data-color='${this.selectedValue}']`)
    if (pre_select) { pre_select.classList.add('selected') }
  }

  pick(event) {
    this.colorTargets.forEach(target => {
      target.classList.remove('selected')
    })

    event.currentTarget.classList.add('selected')

    this.inputTarget.value = event.currentTarget.dataset.color
  }
}
